import { Input, Directive } from '@angular/core';
import { FcComponent } from './fc';
import { ProvidersService } from 'fccore2';
import { ICellRendererParams, IAfterGuiAttachedParams } from 'ag-grid-community';
import 'ag-grid-enterprise';
import { Sysappfields } from 'fccore2';
import { Fcapp } from 'fccore2';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { SystemBusiness } from 'fccore2';
import { CacheService } from 'fccore2';
import { ControlValueAccessor } from '@angular/forms';
export class FcinputComponent extends FcComponent implements ControlValueAccessor, ICellRendererAngularComp {
    // å½ælableçæ¶åçæ¯éï¼å èµ·æ¥ä¸º24
    @Input()
    fcRowSpans: string;
    labelSpan: number = 0;
    valueSpan: number = 24;
    @Input()
    fcShowHelp: string = 'N';
    // æ¹éç¼è¾åè½
    params: any;
    /**
     * @ignore
     */
    _innerValue: any;
    /** ä¸»é®Idå±æ§ */
    @Input()
    fcId: string;
    /** è¾å¥ç±»å */
    @Input()
    fcType: string;
    /** æ ç­¾åç§° */
    @Input()
    fcLabel: string;
    /** è¾å¥æç¤ºç¬¦ */
    @Input()
    fcPlaceHolder: string;
    /** æ¯å¦åªè¯»,é»è®¤ä¸ºå¯è¯»ï¼'Y'è¡¨ç¤ºåªè¯»ï¼'N'è¡¨ç¤ºå¯è¯» */
    @Input()
    fcReadonly: string;
   /**
    * @ignore
    */
    _readonly: boolean;
    /** åæ°æ®id */
    @Input()
    fcAppid: string;
    /** åæ°æ®ç»æ */
    @Input()
    fcApp: Fcapp;
    /** åæ°æ®å­æ®µ */
    @Input()
    fcFieldCode: string;
    fcField: Sysappfields;
    /** æ°å¼ */
    @Input()
    fcData: any;
    /** æ¡ä»¶ */
    @Input()
    fcCondition: string = '';
    /** åéå¼ */
    @Input()
    fcOption: any;
    /** è¾å¥ç»ä»¶åç´ idçå¼ã */
    @Input()
    fcForId: string;
    @Input()
    fcMainObj: any;
    /** æ¯å¦å¿å¡«,é»è®¤ä¸å¿å¡«,'Y'è¡¨ç¤ºå¿å¡«ï¼'N'è¡¨ç¤ºä¸å¿å¡« */
    @Input()
    fcRequired: string = 'N';
    /** 
     * @ignore
     */
    _required: boolean;
    /** æé¿é¿åº¦ */
    @Input()
    fcMaxlen: string = '9999';
    /** 
     * @ignore
     */
    _maxlen: number = 9999;
    /** æå°é¿åº¦ */
    @Input()
    fcMinlen: string = '0';
    /**
     * @ignore
     */
    _minlen: number = 0;
    /** æ¯å¦æ¾ç¤ºlabel,é»è®¤æ¾ç¤ºlabel,'Y'è¡¨ç¤ºæ¾ç¤ºlabelï¼'N'è¡¨ç¤ºä¸æ¾ç¤ºlabel */
    @Input()
    fcShowLabel: string = 'Y';
    /** å¯ç¨éªè¯ */
    @Input()
    fcValid: any;
    //
    _validator: any;
    /** å¸®å© */
    @Input()
    fcHelp: string;
    /**
     * @ignore
     */
    constructor(public provider: ProvidersService, public _id?: string) {
        super(provider, _id);
        this.fcRowSpans = '6,18';
    }
    /**
     * @ignore
     */
    ngOnChanges(param: any) {
        super.ngOnChanges(param);
        if (this.fcShowLabel === 'Y') {
            if (this.fcRowSpans.indexOf(',') === -1) {
                this.fcRowSpans = '6,18';
            }
            try {
                let nums = this.fcRowSpans.split(',');
                if (nums.length > 1) {
                    this.labelSpan = Number(nums[0]);
                    this.valueSpan = Number(nums[1]);
                }
            } catch (e) {
                this.labelSpan = 6;
                this.valueSpan = 18;
            }
        }
        /** ç¦ç¨ */
        this._disabled = this.fcDisabled && this.fcDisabled === 'Y';
        /** åªè¯» */
        this._readonly = this.fcReadonly && this.fcReadonly === 'Y';
        /** å¿å¡« */
        this._required = this.fcRequired && this.fcRequired === 'Y';
        /** placeholder */
        if (this.fcPlaceHolder === undefined) {
            this.fcPlaceHolder = 'è¯·è¾å¥';
        }
        if (this.fcValid && this.fcValid.length !== 0) {
            this._validator = this.fcValid;
        }
        if (this.fcAppid !== undefined && this.fcAppid !== null && this.fcAppid !== ''
            && (this.fcApp === undefined || this.fcApp === null)) {
            this.fcApp = this.appService.getAppById(this.fcAppid);
            if (this.fcApp === null) {
                this.pushDestroy(this.appService.findAppByAid(this.fcAppid).subscribe(result => {
                    if (result.CODE === '0' && result.DATA) {
                        this.fcApp = result.DATA[this.fcAppid];
                        CacheService.set(this.fcAppid, this.fcApp);
                        this.initMainObj(param);
                    } else {
                        this.logService.error(result.MSG);
                    }
                }));
            } else {
                this.initMainObj(param);
            }
        } else if (this.fcApp !== undefined && this.fcApp !== null) {
            this.fcAppid = this.fcApp['APPID'];
            this.initMainObj(param);
        } else {
            this.initMainObj(param);
        }
    }
    // ç¶ç±»åå§åå®æåæ§è¡æ¹æ³
    _afterParentInit(param): void {

    }
    // è·å¾ç¦ç¹
    _focus($event): void {
        this.event('focus', $event);
    }
    // å¤±å»ç¦ç¹
    _blur($event): void {
        this.event('blur', $event);
    };
    _keyup($event) {
        this.event('keyup', $event);
    }
    /**
     * @param event {click}æåºç¹å»äºä»¶
     */
    _click($event: any) {
        this.event('click', $event);
    }
    // è·åå­æ®µçéç½®ä¿¡æ¯
    private initMainObj(param): void {
        this.fcMainObj = {};
        if (this.fcFieldCode !== null && this.fcFieldCode !== undefined
            && this.fcApp !== null && this.fcApp !== undefined) {
            this.fcField = this.appService.getFieldByAppFieldcode(this.fcApp, this.fcFieldCode);
            if (!this.fcField) {
                SystemBusiness.logService.error(this.fcFieldCode + 'å¨æ¨¡å' + this.fcApp.APPNAME + '(' + this.fcApp.APPID + ')ä¸å­å¨');
                return;
            }
            if (this.fcField.ISNULL === 'Y') {
                this._required = true;
            }
            if (this.fcLabel === undefined) {
                this.fcLabel = this.fcField.FIELDNAME;
            }
            /** å¸®å© */
            if (this.fcHelp === undefined) {
                this.fcHelp = this.fcField['HELP'];
            }
            if (this.fcPlaceHolder === undefined) {
                this.fcPlaceHolder = 'è¯·è¾å¥' + this.fcField.FIELDNAME;
                if (this.fcField['PLACEHOLDER'] !== undefined && this.fcField['PLACEHOLDER'] !== null && this.fcField['PLACEHOLDER'] !== '') {
                    this.fcPlaceHolder = 'è¯·è¾å¥' + this.fcField['PLACEHOLDER'];
                }
            }
            this._maxlen = this.fcField.LENGTH; /** æé¿é¿åº¦ */
            if (this.fcField.DICCODE !== '' && this.fcField.DICCODE !== undefined && this.fcField.DICCODE !== null) {
                let dic = this.appService.getDicByAppFieldcode(this.fcApp, this.fcField.FIELDCODE);
                if (dic === undefined || dic === null) {
                    dic = this.appService.getDicAppByAppFieldcode(this.fcApp, this.fcField.FIELDCODE);
                    if (dic !== null && dic !== undefined && dic.length !== 0) {
                        let condition = {};
                        if (this.fcCondition !== undefined && this.fcCondition !== null && this.fcCondition !== '') {
                            try {
                                condition = JSON.parse(this.fcCondition);
                            } catch { throw new Error('fcConditonå¿é¡»æ¯å­ç¬¦ä¸²å¯¹è±¡ï¼{"":""};èæ°æ®ä¸ºï¼' + this.fcCondition); }
                        }
                        this.pushDestroy(this.appService.findWithQuery(dic[0].APPID, condition).subscribe(result => {
                            if (result.CODE === '0') {
                                this.fcOption = result.DATA;
                                param.fcOption = this.fcOption;
                            }
                            this._afterParentInit(param);
                        }));
                    } else {
                        this.pushDestroy(this.daoService.getFromApi(this.fcUrl, Object.assign({}, this.fcRequestParam, { AID: this.fcAppid })).subscribe(result => {
                            if (result.CODE === '0') {
                                this.fcOption = result.DATA;
                                param.fcOption = this.fcOption;
                            }
                            this._afterParentInit(param);
                        }));
                    }
                } else {
                    this.fcOption = dic;
                    param.fcOption = this.fcOption;
                    this._afterParentInit(param);
                }
            } else {
                let condition: any = {};
                if (this.fcCondition !== undefined && this.fcCondition !== null && this.fcCondition !== '') {
                    try {
                        condition = JSON.parse(this.fcCondition);
                    } catch (e) { throw new Error('fcConditonå¿é¡»æ¯å­ç¬¦ä¸²å¯¹è±¡ï¼{"":""}'); }
                }
                if (this._id !== 'fc-text') {
                    condition.AID = this.fcAppid;
                    this.pushDestroy(this.daoService.getFromApi(this.fcUrl, Object.assign({}, this.fcRequestParam, condition)).subscribe(result => {
                        if (result.CODE === '0') {
                            this.fcOption = result.DATA;
                            param.fcOption = this.fcOption;
                        }
                        this._afterParentInit(param);
                    }));
                } else {
                    this._afterParentInit(param);
                }
            }
        } else if (this.fcUrl !== 'SYSTEM/SYSMODEL/listinfo') {
            let condition: any = {};
            if (this.fcCondition !== undefined && this.fcCondition !== null && this.fcCondition !== '') {
                try {
                    condition = JSON.parse(this.fcCondition);
                } catch (e) { throw new Error('fcConditonå¿é¡»æ¯å­ç¬¦ä¸²å¯¹è±¡ï¼{"":""}'); }
            }
            let requestParam = {};
            if (!(this.fcRequestParam instanceof Object)) {
                try {
                    requestParam = JSON.parse(this.fcRequestParam);
                } catch (e) { throw new Error('fcRequestParamå¿é¡»æ¯å¯¹è±¡ï¼{"":""}'); }
            } else {
                requestParam = {...this.fcRequestParam};
            }
            this.pushDestroy(this.daoService.getFromApi(this.fcUrl, {...requestParam, ...condition}).subscribe(result => {
                if (result.CODE === '0') {
                    if (this._id === 'fc-listdata') {
                        // tslint:disable-next-line:no-string-literal
                        this['fcRowData'] = result.DATA;
                    } else {
                        this.fcOption = result.DATA;
                        param.fcOption = this.fcOption;
                    }
                    this.fcData = result.DATA;
                }
                this._afterParentInit(param);
            }));
        } else {
            this._afterParentInit(param);
        }
    }
    /**
     * @ignore
     */
    get innerValue(): any {
        return this._innerValue;
    }
    /**
     * @ignore
     */
    set innerValue(v: any) {
        this._innerValue = v;
        this.onChangeCallback(v);
    }
    /**
     * @ignore
     */
    public onTouchedCallback: () => void = function() {  };
    /**
     * @ignore
     */
    public onChangeCallback: (_: any) => void = function() {  };
    /**
     * @ignore
     */
    writeValue(value: any) {
        this._innerValue = value;
        this._afterParentInit({});
    }
    /**
     * @ignore
     */
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    /**
     * @ignore
     */
    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }
    /**
     * @ignore
     */
    refresh(params: any): boolean { return false; }
    /**
     * @ignore
     */
    agInit(params: ICellRendererParams): void { }
    /**
     * @ignore
     */
    afterGuiAttached?(params?: IAfterGuiAttachedParams): void { }
    /**
     * @ignore
     */
    checkValidator(value: any) {
        if (this.fcValid) {
            const validator = this._validator;
            /** å½åä¸»å¯¹è±¡çæ ¡éªè§å */
            const valid = validator.validators;
            /** å½åä¸»å¯¹è±¡æ ¡éªè§åéè¯¯è¯´æ */
            const message = validator.errorMessages;
            /** å¤æ­æ¯å¦å¿å¡« */
            validator.show = 'N';
            validator.showValidator = '';
            if (valid.required && (!value || value.length === 0)) {
                validator.show = 'Y';
                validator.showValidator = 'required';
            }
            if (value && (value.length > valid.maxLength)) {
                validator.show = 'Y';
                validator.showValidator = 'maxLength';
            }
            if (valid.customVal) {
                validator.show = 'Y';
                validator.showValidator = 'customVal';
            }
            this.fcValid = this._validator;
        }
    }
}
